import DirectedGraph from './DirectedGraph';

export default DirectedGraph;
